/**
 * Whether a stale bundle should be stopped from STARTING a transaction.
 *
 * The update banner is advisory, and that is right for someone part-way through a capture: a reload discards
 * staged fingerprints and typed demographics, so forcing it would trade one support call for a worse one.
 *
 * Starting is different. Workflow configurations are runtime data, so a stale bundle reads the CURRENT
 * configuration with OLD code — and a configuration whose work has moved into rules the old bundle cannot
 * execute produces an EFT with no composed name, no copied ORI and no device fields. Silently. That is worth
 * blocking, because the alternative is a submission the FBI rejects days later.
 *
 * So: block at the door, never mid-room.
 */
export function shouldBlockStart(stale: boolean, hasWorkInProgress: boolean): boolean {
  return stale && !hasWorkInProgress;
}
